import {Optional, Subscription} from 'data/types'
import published from 'utils/published'
import selector, {identitySelector} from 'utils/selector'
import APIService from './APIService'
import services from 'services'

class BillingService {
  public subscription = published<Optional<Subscription>>(null)

  public constructor() {
    this.loadSubscription()
  }

  private loadSubscription = async () => {
    this.subscription.startLoading()
    const result = await APIService.getBillingSubscription()
    if (result.ok) {
      this.subscription.publish(result.body)
    }
    this.subscription.endLoading()
  }

  public openCheckout = async () => {
    const {loadStripe} = await import('@stripe/stripe-js')
    const result = await APIService.getCheckoutSessionId()
    if (!result.ok) {
      return // TODO: Handle error
    }
    const stripe = await loadStripe(services.config.stripePublicKey)
    stripe?.redirectToCheckout({
      sessionId: result.body,
    })
  }
}

export const billingServiceSelector = selector(identitySelector<string>(), () => new BillingService())
